import { render, staticRenderFns } from "./RecievedTickets.vue?vue&type=template&id=3bbef5e1&"
import script from "./RecievedTickets.vue?vue&type=script&lang=js&"
export * from "./RecievedTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports